import React, { useState } from "react";
import { Modal, ModalBody } from "reactstrap";

import { CurrentLevel, Progress, TargetLevel } from "../../utils/Constant";
import MUIIcons from "../MUIIcon/MUIIcons";
import TargetLevelModal, { TargetLevelModalData } from "../TargetLevelModal";

import "./style.scss";

interface LevelTrackerProps {
  currentLevel: string;
  targetLevel: string;
  progress: number | string;
  userId?;
  getAllLevelData?;
  infoData: TargetLevelModalData[];
}

const LevelTracker: React.FC<LevelTrackerProps> = ({
  currentLevel,
  targetLevel,
  progress,
  getAllLevelData,
  infoData,
  userId,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => {
    if (!isModalOpen) {
      getAllLevelData();
    }
    setIsModalOpen(!isModalOpen);
  };

  return (
    <div className="level-tracker">
      <div className="level-tracker__metrics">
        <div className="level-tracker__level-container">
          <div className="level-tracker__level-label d-flex align-items-center gap-2">
            {CurrentLevel}
            <MUIIcons
              className="pointer"
              iconName="InfoOutlined"
              size={24}
              onClick={toggleModal}
            />
          </div>
          <div className="level-tracker__level-value">{currentLevel}</div>
        </div>

        <div className="level-tracker__connector-container">
          <div className="level-tracker__connector">
            <div className="level-tracker__connector-dot"></div>
            <div className="level-tracker__connector-line"></div>
            <div className="level-tracker__connector-dot"></div>
          </div>
        </div>

        <div className="level-tracker__level-container">
          <div className="level-tracker__level-label">{TargetLevel}</div>
          <div className="level-tracker__level-value">{targetLevel}</div>
        </div>
      </div>

      <div className="level-tracker__progress-header">
        <div className="level-tracker__progress-label">{Progress}</div>
        <div className="level-tracker__progress-value">{progress}%</div>
      </div>

      <div className="level-tracker__progress-container">
        <div
          className="level-tracker__progress-bar"
          style={{ width: `${progress}%` }}
        ></div>
      </div>

      <div className="level-tracker__markers">
        <span className="level-tracker__marker">0%</span>
        <span className="level-tracker__marker">25%</span>
        <span className="level-tracker__marker">50%</span>
        <span className="level-tracker__marker">75%</span>
        <span className="level-tracker__marker">100%</span>
      </div>

      <Modal isOpen={isModalOpen} toggle={toggleModal}>
        <ModalBody>
          <TargetLevelModal targetLevelData={infoData} userId={userId} />
        </ModalBody>
      </Modal>
    </div>
  );
};

export default LevelTracker;
